import { DEFAULT_BACKGROUND_VARIANT } from './appBackgroundVariants';

export const HOME_TAB_ID = 'id_HomeTab';
export const FEED_TAB_ID = 'id_FeedTab';
export const DISCOVER_TAB_ID = 'id_DiscoverTab';
export const EVENTS_TAB_ID = 'id_EventsTab';
export const VENUE_TAB_ID = 'id_VenueTab';
export const FRIENDS_TAB_ID = 'id_FriendsTab';
export const CHAT_TAB_ID = 'id_ChatTab';
export const BANDS_TAB_ID = 'id_BandsTab';
export const BILLING_TAB_ID = 'id_BillingTab';
export const SYSTEM_HEALTH_TAB_ID = 'id_SystemHealthTab';

export const MAIN_NAVIGATION_TAB_IDS = Object.freeze({
    HOME: HOME_TAB_ID,
    FEED: FEED_TAB_ID,
    DISCOVER: DISCOVER_TAB_ID,
    EVENTS: EVENTS_TAB_ID,
    VENUE: VENUE_TAB_ID,
    FRIENDS: FRIENDS_TAB_ID,
    CHAT: CHAT_TAB_ID,
    BANDS: BANDS_TAB_ID,
    BILLING: BILLING_TAB_ID,
    SYSTEM: SYSTEM_HEALTH_TAB_ID,
});

export const MAIN_NAVIGATION_TAB_SPECS = [
    {
        id: HOME_TAB_ID,
        label: 'Home',
        labelKey: 'navigation.tabs.home',
        isAuthReq: false,
        backgroundVariant: DEFAULT_BACKGROUND_VARIANT,
    },
    {
        id: FEED_TAB_ID,
        label: 'Feed',
        labelKey: 'navigation.tabs.feed',
        isAuthReq: false,
        backgroundVariant: 'twilight',
    },
    {
        id: DISCOVER_TAB_ID,
        label: 'Discover',
        labelKey: 'navigation.tabs.discover',
        isAuthReq: false,
        backgroundVariant: DEFAULT_BACKGROUND_VARIANT,
    },
    {
        id: EVENTS_TAB_ID,
        label: 'Events',
        labelKey: 'navigation.tabs.events',
        isAuthReq: false,
        backgroundVariant: DEFAULT_BACKGROUND_VARIANT,
    },
    {
        id: VENUE_TAB_ID,
        label: 'Venue',
        labelKey: 'navigation.tabs.venue',
        isAuthReq: false,
        backgroundVariant: DEFAULT_BACKGROUND_VARIANT,
    },
    {
        id: FRIENDS_TAB_ID,
        label: 'People',
        labelKey: 'navigation.tabs.friends',
        isAuthReq: false,
        backgroundVariant: 'aurora',
    },
    {
        id: CHAT_TAB_ID,
        label: 'Chat',
        labelKey: 'navigation.tabs.chat',
        isAuthReq: false,
        backgroundVariant: 'pulse',
    },
    {
        id: BANDS_TAB_ID,
        label: 'Bands',
        labelKey: 'navigation.tabs.bands',
        isAuthReq: false,
        backgroundVariant: 'sunrise',
    },
    {
        id: BILLING_TAB_ID,
        label: 'Billing',
        labelKey: 'navigation.tabs.billing',
        isAuthReq: true,
        backgroundVariant: 'nebula',
    },
    {
        id: SYSTEM_HEALTH_TAB_ID,
        label: 'System',
        labelKey: 'navigation.tabs.system',
        isAuthReq: true,
        requiredRoles: ['ROLE_ADMIN'],
        backgroundVariant: 'nebula',
    },
];
